import React, { PropsWithChildren } from "react";

import { cn } from "helpers/style";
import {
  AlignContent,
  AlignItems,
  Direction,
  JustifyContent,
  Lg,
  Md,
  Sm,
  Wrap,
} from "./types";
import styles from "./Grid.module.scss";

type Props = PropsWithChildren<{
  className?: string;
  alignContent?: AlignContent;
  justifyContent?: JustifyContent;
  alignItems?: AlignItems;
  direction?: Direction;
  wrap?: Wrap;
  sm?: Sm;
  md?: Md;
  lg?: Lg;
  container?: boolean;
  item?: boolean;
  zeroMinWidth?: boolean;
  flat?: boolean;
  flatMd?: boolean;
  flatLg?: boolean;
  spacing?: number;
  spacingMd?: number;
  spacingLg?: number;
}>;

const Grid: React.FC<Props> = ({
  className,
  alignContent = "stretch",
  justifyContent = "flex-start",
  alignItems = "stretch",
  direction = "row",
  wrap,
  sm = false,
  md = false,
  lg = false,
  container = false,
  item = false,
  zeroMinWidth = false,
  flat = false,
  flatMd = false,
  flatLg = false,
  spacing,
  spacingMd,
  spacingLg,
  children,
}) => {
  return (
    <div
      className={cn([
        styles.grid,
        className,
        container && styles.gridContainer,
        item && styles.gridItem,
        zeroMinWidth && styles.gridZeroMinWidth,
        (sm === true || md === true || lg === true) && styles.gridFullWidth,
        (sm === "auto" || md === "auto" || lg === "auto") &&
          styles.gridAutoWidth,
        sm && item && styles[`gridSm${sm}`],
        md && item && styles[`gridMd${md}`],
        lg && item && styles[`gridLg${lg}`],
        spacing && styles[`gridSpacingSm${spacing}`],
        spacingMd && styles[`gridSpacingMd${spacingMd}`],
        spacingLg && styles[`gridSpacingLg${spacingLg}`],
        flat && styles.gridSpacingFlatSm,
        flatMd && styles.gridSpacingFlatMd,
        flatLg && styles.gridSpacingFlatLg,
        className,
      ])}
      style={{
        flexDirection: direction,
        justifyContent: justifyContent,
        alignContent: alignContent,
        alignItems: alignItems,
        flexWrap: wrap,
      }}
    >
      {children}
    </div>
  );
};

export default Grid;
